import React, {
  useContext, useMemo,
} from 'react';
import { makeStyles } from '@mui/styles';
import {
  Divider, Grid, Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import config from '../config';
import { GeneralContext } from '../util/Store';

const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: 'auto',
    paddingTop: '50px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    // Avoid clipping with third party bottom content like arena chat.
    marginBottom: 32,
  },
  flex: {
    margin: 0,
    display: 'flex',
    flexFlow: 'column wrap',
    justifyContent: 'center',
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  flexItem: {
    flexBasis: 'auto',
    textAlign: 'center',
    padding: '10px',
    borderLeft: 'solid 0px white',
    [theme.breakpoints.up('sm')]: {
      borderLeft: 'solid 0px white',
    },
  },
  a: {
    color: theme.palette.background.contrastText || '#000',
    '&:hover': {
      color: theme.palette.background.hover || '#ccc',
    },
    fontSize: '16px',
    fontWeight: 400,
  },
}));

export default observer(() => {
  const classes = useStyles();
  const generalStore = useContext(GeneralContext);
  const isIframe = useMemo(() => window.self !== window.top, []);

  if (isIframe) return null;

  return (
    <section className={classes.footer}>
      <Grid container>
        {generalStore.contactInfo && (
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
            <div style={{ width: 400 }}>
              <Typography variant="body1" sx={{ marginBottom: 2 }}>
                <b>Service-Kontakt:</b>
                <br />
                {generalStore.contactInfo.name}
                <br />
                {generalStore.contactInfo.tel && (
                  <>
                    Tel.:
                    {' '}
                    <a href={`tel:${generalStore.contactInfo.tel}`}>{generalStore.contactInfo.telDisplay}</a>
                    <br />
                  </>
                )}
                E-Mail:
                {' '}
                <a href={`mailto:${generalStore.contactInfo.email}`}>{generalStore.contactInfo.email}</a>
              </Typography>
              <Divider />
            </div>
          </Grid>
        )}
        <Grid item xs={12}>
          <div className={classes.flex}>
            {(generalStore.footerLinks || config.footerLinks).map(({ name, link }) => (
              <div className={classes.flexItem} key={name}>
                <a
                  className={classes.a}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                >
                  <Typography variant="subtitle2">
                    {name}
                  </Typography>
                </a>
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
    </section>
  );
});
